import axios from 'axios';

// Sem NEXT_PUBLIC_API_KEY_SYSTEM o baseURL ficava undefined e o axios chamava
// /crews/get_all na origem do proprio site, tomava 404 e o site abria vazio.
export const API_BASE_URL = process.env.NEXT_PUBLIC_API_KEY_SYSTEM || 'https://voidhubsystem.com';

if (!process.env.NEXT_PUBLIC_API_KEY_SYSTEM && process.env.NODE_ENV !== 'production') {
  console.warn(`[VOID] NEXT_PUBLIC_API_KEY_SYSTEM nao definida — usando ${API_BASE_URL}`);
}

export const AUTH = axios.create({
  baseURL: API_BASE_URL,
});
